// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1OK78","label":"LabeledBox_label__26bt4"};